
import './EmailsForSubscribers.css';

import axios from 'axios';
import { useState, useRef, useEffect } from 'react';
import React from 'react';
import { useToast } from '../../CustomeHooks/useToast';


const EmailsForSubscribers = ({ jobsIds }) => {

    const [isSending, setIsSending] = useState(false);
    const toast = useToast();

    //console.log("EmailsForSubscribers triggered with jobsIds = ", jobsIds);

    const sendEmails = () => {

        //console.log("jobsIds", jobsIds);
        
        
        axios.post(`${process.env.REACT_APP_URL}/api/EmailsForSubscribers`, 
            { 
                activatedJobsIDs: jobsIds
            }, 
            {
                headers: {
                    //"Authorization": `Bearer ${ bearerToken }`,
                    "Authorization": process.env.REACT_APP_TOKEN,
                    "Content-Type": "application/json"
                },
            }
        )
        .then(res => {
            if(res.data.status === "success") {
                //setData(res.data.items);
                toast("success", res.data.message);
            }
            else if(res.data.status === "failed") {
                toast("error", res.data.message);
            }
        })
        .catch((error) => {
            console.log("error = ", error);
            toast("error", "error while executing select query");
        })
        .finally(() => {
            setIsSending(false);
        });
    }

    return (
        <div className='emails-for-subscribers'>
            <form>
                📧 <input type="text"
                    name="jobs-ids"
                    className='jobs-ids'
                    value={ jobsIds.join(" - ") }
                    readOnly/>

                <input type="button" className='send-emails'
                    name="send-emails"
                    value={ isSending ? "Sending Emails..." : "Send Emails to Subscribers" } 
                    disabled={ isSending }
                    onClick={ sendEmails }
                />
            </form>
        </div>
    );
}

export default React.memo(EmailsForSubscribers);